var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.36602 5.5C3.98112 6.16667 3.01887 6.16667 2.63397 5.5L0.468911 1.75C0.0840111 1.08333 0.565137 0.249999 1.33494 0.249999L5.66507 0.25C6.43487 0.25 6.91599 1.08333 6.53109 1.75L4.36602 5.5Z","fill":"#F3575D"}));
}

Arrow.defaultProps = {"width":"7","height":"6","viewBox":"0 0 7 6","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
